import { Socket } from "socket.io-client";
import { displayErrorToast } from "src/components/shared/Toasts/Toast";
import { ToastIds } from "src/enums/errorToastIds";
import { GameActions } from "../game/game.reducer";
import { ActionTypes } from "../game/game.reducer.types";
import { GameModel } from "../models/game/game.model";
import { TaskModel } from "../models/task/task.model";
import { TimerChangeModel } from "../socket/events/TimerChange/timerChange.model";
import { UserChangeModel } from "../socket/events/UserChange/userChange.model";
import { VoteChangeModel } from "../socket/events/VoteChange/voteChange.model";
import { VoteRevealModel } from "../socket/events/VoteReveal/voteReveal.model";
import { EventType } from "../socket/socket.events";
import { TaskUpdateModel } from "./events/TaskUpdate/taskUpdate.model";

export const registerListeners = (
  socket: Socket,
  dispatch: React.Dispatch<GameActions>
) => {
  const {
    USER_CHANGE,
    VOTE_CHANGE,
    TIMER_CHANGE,
    TASK_LIST_UPDATE,
    VOTE_REVEAL,
    NEW_VOTING,
    SIO_CONNECT_ERROR,
    SIO_RECONNECT_FAILED,
    GAME_SUMMARY,
  } = EventType;
  socket.on(SIO_CONNECT_ERROR, () =>
    displayErrorToast(
      "src/socketIO connection error. Please refresh the page.",
      ToastIds.CONNECT_ERROR
    )
  );
  socket.on(SIO_RECONNECT_FAILED, () =>
    displayErrorToast(
      "Couldn't reconnect SocketIO. Please refresh the page.",
      ToastIds.RECONNECT_FAILED
    )
  );

  socket.on(USER_CHANGE, (data: UserChangeModel) =>
    onUserChange(data, dispatch)
  );
  socket.on(VOTE_CHANGE, (data: VoteChangeModel) =>
    onVoteChange(data, dispatch)
  );
  socket.on(TIMER_CHANGE, (data: TimerChangeModel) =>
    onTimerChange(data, dispatch)
  );
  socket.on(TASK_LIST_UPDATE, (data: TaskUpdateModel) => onTaskListUpdate(data, dispatch));
  socket.on(VOTE_REVEAL, (data: VoteRevealModel) =>
    onVoteReveal(data, dispatch)
  );
  socket.on(NEW_VOTING, (data: GameModel) => onNewVoting(data, dispatch));
  socket.on(GAME_SUMMARY, (data: TaskModel[]) => onGameSummary(data, dispatch));
};

export const deregisterListeners = (socket: Socket) => {
  const {
    USER_CHANGE,
    VOTE_CHANGE,
    TIMER_CHANGE,
    TASK_LIST_UPDATE,
    VOTE_REVEAL,
    NEW_VOTING,
    SIO_CONNECT_ERROR,
    SIO_RECONNECT_FAILED,
    GAME_SUMMARY,
  } = EventType;
  socket.off(SIO_CONNECT_ERROR);
  socket.off(SIO_RECONNECT_FAILED);
  socket.off(USER_CHANGE);
  socket.off(VOTE_CHANGE);
  socket.off(TIMER_CHANGE);
  socket.off(TASK_LIST_UPDATE);
  socket.off(VOTE_REVEAL);
  socket.off(NEW_VOTING);
  socket.off(GAME_SUMMARY);
  socket.off(TASK_LIST_UPDATE);
};

export const onUserChange = (
  data: UserChangeModel,
  dispatch: React.Dispatch<GameActions>
) => dispatch({ type: ActionTypes.USER_CHANGE, data });

export const onVoteChange = (
  data: VoteChangeModel,
  dispatch: React.Dispatch<GameActions>
) => dispatch({ type: ActionTypes.VOTE_CHANGE, data });

export const onTimerChange = (
  data: TimerChangeModel,
  dispatch: React.Dispatch<GameActions>
) => dispatch({ type: ActionTypes.TIMER_CHANGE, data });

export const onVoteReveal = (
  data: VoteRevealModel,
  dispatch: React.Dispatch<GameActions>
) => dispatch({ type: ActionTypes.VOTE_REVEAL, data });

export const onNewVoting = (
  data: GameModel,
  dispatch: React.Dispatch<GameActions>
) => dispatch({ type: ActionTypes.NEW_VOTING, data });

export const onGameSummary = (
  data: TaskModel[],
  dispatch: React.Dispatch<GameActions>
) => dispatch({ type: ActionTypes.GAME_SUMMARY, data });

export const onTaskListUpdate = (
  data: TaskUpdateModel,
  dispatch: React.Dispatch<GameActions>
) => dispatch({ type: ActionTypes.TASK_LIST_UPDATE, data });
